import { render, staticRenderFns } from "./StaffAssignmentEdit.vue?vue&type=template&id=4a1db984&scoped=true&"
import script from "./StaffAssignmentEdit.vue?vue&type=script&lang=js&"
export * from "./StaffAssignmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./StaffAssignmentEdit.vue?vue&type=style&index=0&id=4a1db984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1db984",
  null
  
)

export default component.exports